"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineAlertSuccess = void 0;
var _react = _interopRequireDefault(require("react"));
var _DoneOutlined = _interopRequireDefault(require("@material-ui/icons/DoneOutlined"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var InlineAlertSuccess = exports.InlineAlertSuccess = function InlineAlertSuccess(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-alert-success font-weight-bold"
  }, /*#__PURE__*/_react["default"].createElement(_DoneOutlined["default"], null), /*#__PURE__*/_react["default"].createElement("span", null, " ", props.message));
};
//# sourceMappingURL=inlineAlertSuccess.js.map